<template>
  <div class="informLabel" :class="pageSettings.pageInfo.type" v-if="pageSettings.pageInfo.text">
    <span>
      {{pageSettings.pageInfo.text}}
    </span>
  </div>
</template>

<script>
import {usePageSettings} from "../../composables/usePageSettings";
export default {
  name: "PageInfo",
  setup: (props, ctx) => {
    const {pageSettings} = usePageSettings();
    return {
      pageSettings
    }
  }
}
</script>

<style lang="scss" scoped>
.informLabel {
    text-align: center;
    background: #fff;
    padding: 10px;
    margin-bottom: 10px;
    z-index: 99;
    position: relative;
    span {
      display: inline-block;
    }
    &.warning {
       background: #ffad38;
       color: #fff;
      &:before {
       content: "";
       display: inline-block;
       width: 27px;
       height: 27px;
       background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMzJweCIgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTQuNDcgMjFoMTUuMDZjMS41NCAwIDIuNS0xLjY3IDEuNzMtM0wxMy43MyA0Ljk5Yy0uNzctMS4zMy0yLjY5LTEuMzMtMy40NiAwTDIuNzQgMThjLS43NyAxLjMzLjE5IDMgMS43MyAzek0xMiAxNGMtLjU1IDAtMS0uNDUtMS0xdi0yYzAtLjU1LjQ1LTEgMS0xczEgLjQ1IDEgMXYyYzAgLjU1LS40NSAxLTEgMXptMSA0aC0ydi0yaDJ2MnoiPjwvcGF0aD48L3N2Zz4=");
       vertical-align: middle;
       margin-right: 10px;
       background-size: contain;
     }
    }
  &.danger {
     background: #ff3838;
     color: #fff;
  &:before {
     content: "";
     display: inline-block;
     width: 27px;
     height: 27px;
     background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMzJweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMzJweCIgZmlsbD0iI2ZmZmZmZiI+PHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTAgMTFjLS41NSAwLTEtLjQ1LTEtMVY4YzAtLjU1LjQ1LTEgMS0xczEgLjQ1IDEgMXY0YzAgLjU1LS40NSAxLTEgMXptMSA0aC0ydi0yaDJ2MnoiPjwvcGF0aD48L3N2Zz4=");
     vertical-align: middle;
     margin-right: 10px;
     background-size: contain;
   }
  }
}
</style>